/* eslint-env browser */
// A click that ends a text selection is not a click to open a record
// (call-centre feedback, 29 Oct 2026: staff drag across a booking reference
// or a phone number in a clickable row or link to copy it). Used by the
// Bookings rows and ClickableBookingLink; no React, no reads.
//
//   const pressRef = useRef(null);
//   <tr onMouseDown={(e) => { pressRef.current = pressPoint(e); }}
//       onClick={(e) => { if (!selectingTextIn(e.currentTarget, e, pressRef.current)) open(row); }}>

/** Where a mouse press happened ({ x, y }), or null. */
export const pressPoint = (event) => (event && Number.isFinite(event.clientX) ? { x: event.clientX, y: event.clientY } : null);

/**
 * True when this click ends a text selection inside `el`, so it must not
 * open anything. With the press point it counts only when the pointer moved
 * more than 3 px (a drag): a plain click on text selected earlier still
 * opens, because Chrome keeps the old selection until after that click.
 * Without the press point, any selection inside `el` counts.
 */
export const selectingTextIn = (el, event, press) => {
  try {
    if (press && event && Math.abs(event.clientX - press.x) <= 3 && Math.abs(event.clientY - press.y) <= 3) return false;
    const sel = typeof window !== 'undefined' && typeof window.getSelection === 'function' ? window.getSelection() : null;
    if (!sel || !el || String(sel).length === 0) return false;
    return (!!sel.anchorNode && el.contains(sel.anchorNode)) || (!!sel.focusNode && el.contains(sel.focusNode));
  } catch (e) {
    return false;
  }
};
